// Pour une documentation complète sur API, incluant des exemples de code, allez sur http://wix.to/94BuAAs
import wixData from 'wix-data';
import wixWindow from 'wix-window';

let i = 0;
let items;


let slidersize;

$w.onReady(function () {
	if(wixWindow.formFactor === "Mobile"){
	slidersize=1;
	} 
	else
	{
		slidersize=3;
	}

	 $w('#productPage1').getProduct().then((ev) => {
		 i = 0;
		 wixData.query("RelatedProducts").eq("product", ev._id)
			.find()
			.then( (relatedProducts) => {
				let relatedProductsItems = relatedProducts.items
				
				if(relatedProductsItems.length > 0) {
					wixData.query("Stores/Products")
					.include("collections")
					.hasSome("collections", relatedProductsItems[0]['collection'])	
					.find()
					.then( (results) => {
						items = results.items;
						if(items.length > 0) {
							if(items.length > i+slidersize) {
								$w('#repeater1').data = items.slice(i, i+slidersize);
								$w('#repeater1').show();
								$w('#button5').show();
								$w('#button6').show();
								$w('#text51').show();
							}
							else
							{
								$w('#repeater1').data = items;
								$w('#repeater1').show();
								//Pas de bouton si slider trop petit
								$w('#text51').show();
								i=(i+slidersize)-items.length;
							}
						}						
					}).catch((error) => {
						console.log(error);
					});
				}
			})
			.catch((error) => {
				console.log(error);
			});
	 });

	 $w("#repeater1").onItemReady( ($item, itemData, index) => {
		 $item('#image3').src = itemData.mainMedia;
		 $item('#image3').link = itemData.productPageUrl;
		 $item('#text50').text = itemData.name;
	 })
});

export function button5_click(event) {
	if(i < items.length) {
		i = i + slidersize;
		$w('#repeater1').data = items.slice(i, i+slidersize);
		if(items.length > i+slidersize) {
			$w('#repeater1').data = items.slice(i, i+slidersize);
		}
		else
		{
			$w('#repeater1').data = items.slice(i, i+slidersize).concat(items.slice(0, (i+slidersize)-items.length));			
			i=i-items.length;
		}
	}
}

export function button6_click(event) {
	i=i - slidersize;
	if(i < 0) {
		i=items.length+i
	}

	if(items.length > i+slidersize) {
		$w('#repeater1').data = items.slice(i, i+slidersize);
	}
	else
	{
		$w('#repeater1').data = items.slice(i, i+slidersize).concat(items.slice(0, (i+slidersize)-items.length));
		i=i-items.length;
	}
}